module.exports = __webpack_public_path__ + "img/ing-light.540cac7.png";